/**
 * On Range Short Game Play Reducers
 */
import {
    ORTSHORTGAME_ACTION,
    ALL_ORTSHORTGAME,
    ADD_ORTSHORTGAME,
    FETCH_ORTSHORTGAME,
    EDIT_ORTSHORTGAME,
    DELETE_ORTSHORTGAME,
    FETCH_ORTSHORTGAMECHART,
    FETCH_ORTSHORTGAMESHOTCHART,
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    ortshortgamelist:[],
    particularortshortgame:[],  
    ortshortgamechart:[],
    ortshortgameshotchart:[],  
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case ORTSHORTGAME_ACTION:
            return { ...state, loading: true };       

        case ALL_ORTSHORTGAME:
            return { ...state, loading: false, ortshortgamelist: action.payload };     
            
        case ADD_ORTSHORTGAME:
            return { ...state, loading: false };     
         
        case FETCH_ORTSHORTGAME:
            return { ...state, loading: false, particularortshortgame: action.payload };  
            
        case EDIT_ORTSHORTGAME:
            return { ...state, loading: false }; 
            
        case DELETE_ORTSHORTGAME:
            return { ...state, loading: false };     

        case FETCH_ORTSHORTGAMECHART:
            return { ...state, loading: false, ortshortgamechart: action.payload };  

        case FETCH_ORTSHORTGAMESHOTCHART:
            return { ...state, loading: false, ortshortgameshotchart: action.payload }; 
        
        default: return { ...state };

     }
 }